export interface AuthToken {
  _id: string;
  createdAt: string;
  userInfo: {
    os: string;
    browser: string;
    platform: string;
    isMobile: boolean;
    city?: string;
    state?: string;
  };
}

export const BuildAuthToken = (data): AuthToken => {
  return {
    _id: typeof data === 'string' ? data : data._id,
    createdAt: data.createdAt || '',
    userInfo: {
      os: data?.userInfo?.os || '',
      browser: data?.userInfo?.browser || '',
      platform: data?.userInfo?.platform || '',
      isMobile: data?.userInfo?.isMobile || '',
      city: data?.userInfo?.city || '',
      state: data?.userInfo?.state || ''
    }
  };
};
